import { makeStyles } from '@fluentui/react-components';

export const useStyles = makeStyles({
    dialogContent: {
        fontSize: "16px", 
    },
});